
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  computed,
  defineAsyncComponent,
  defineComponent, onMounted, reactive, ref, SetupContext, toRaw,
} from 'vue';
import {
  Button, Table, Modal, message, Input, Radio,
} from 'ant-design-vue';
import Draggable from 'vuedraggable';
import {
  PlusCircleFilled, PlusOutlined, FormOutlined, MenuOutlined, SwapOutlined, DeleteOutlined,
} from '@ant-design/icons-vue';
import { definitions } from '@/types/api';
import { cloneDeep, uniqBy, uniqueId } from 'lodash';
import { useRoute } from 'vue-router';
import { Question, QuestionI } from './question/js/interface';
import {
  getModuleId,
  questionColumn,
  delCustomQuestionModuleIds,
  delCustomQuestionIds,
  editCustomQuestionModule,
  editCustomQuestion,
  editsSeqCustomQuestion,
  editsModuleIdCustomQuestion,
  listCustomQuestionModuleByCaId,
  listCustomQuestionByMId,
} from './js/jobAnalysiss';
import { parseData, questionTypes } from './question/js';

// import { mock } from '@/axios/fetch';
// import MockPath from '@/mock/mock_api';
// const mockPath = new MockPath();

export default defineComponent({
  name: 'JobAnalysis',
  components: {
    aTable: Table,
    aButton: defineAsyncComponent(() => import('@/components/asynButton.vue')),
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    Draggable,
    aModal: Modal,
    FormOutlined,
    MenuOutlined,
    PlusCircleFilled,
    PlusOutlined,
    aInput: Input,
    SwapOutlined,
    DeleteOutlined,
    draggableTable: defineAsyncComponent(() => import('@/components/public/draggableTable/index.vue')),
    QuestionVue: defineAsyncComponent(() => import('./question/index.vue')),
  },
  setup(this, props, ctx: SetupContext) {
    const route = useRoute();
    // questionModules
    const modals = reactive({
      modules: false, // 模块管理-模态框
      questionMove: false, // 题目模块移动-模态框
      addQuestion: false,
    });
    const loadings = reactive({
      modulesSaving: false, // 模块保存loading
      moveLoding: false, // 移动loading
    });
    const currentModuleId = ref('');

    const questionTypeFilter = (qType: number) => questionTypes.value[qType].name;
    // 根据jobId 查询 questionModules
    const questionModules = ref([] as (definitions['CustomQuestionModule']&{uid: string})[]);
    const questionModulesClone = ref([] as (definitions['CustomQuestionModule']&{uid: string})[]);

    /** 获module */
    const queryQuestionModuleList = async () => {
      const list = await listCustomQuestionModuleByCaId(route.params.jobId as string);
      questionModules.value = list as [];
    };

    // 模块按钮点击事件
    const handleModuleBtnClick = (mo: { uid: string; id: string }) => {
      const { uid, id: moduleId } = mo;
      if (currentModuleId.value !== uid) {
        currentModuleId.value = uid;
        queryQuestionList(moduleId);
      }
    };

    const handleModuleManageClick = () => {
      questionModulesClone.value = cloneDeep(toRaw(questionModules.value)); // [...toRaw(questionModules.value)];//
      delModuleIds.clear();
      modals.modules = true;
    };

    const handleAddModuleClick = (isInit = false) => {
      console.log(route.params, 'route.params');
      questionModulesClone.value.push({
        assignmentId: route.params.jobId as string,
        moduleName: isInit ? '模块一' : '',
        id: undefined,
        uid: uniqueId(''),
        seq: questionModulesClone.value.length,
      } as definitions['CustomQuestionModule']&{uid: string});
    };

    /** 删除 */
    const delModuleIds: Set<string> = new Set();
    const handleDelModuleClick = async (moIndex: number, record: definitions['CustomQuestionModule']) => {
      if (record.id) {
        delModuleIds.add(record.id);
        // await delCustomQuestionModule(record.id as string);
      }
      questionModulesClone.value.splice(moIndex, 1);
    };

    const onModuleDragEnd = () => {
      questionModulesClone.value.forEach((d, index) => {
        d.seq = index;
      });
    };

    // eslint-disable-next-line consistent-return
    const handleSaveModulesClick = async () => {
      const notEmpty = questionModulesClone.value.every((d) => (d.moduleName as string).trim().length);
      const notRepeat = uniqBy(questionModulesClone.value, 'moduleName').length === questionModulesClone.value.length;
      if (!notEmpty) return message.info('模块名不能为空，请重新输入！');
      if (!notRepeat) return message.info('模块名不能重复，请重新输入！');
      onModuleDragEnd(); // 重排序
      const data = [...questionModulesClone.value].map((d) => ({ ...d, uid: undefined }));
      // data.map((d) => { delete (d as any).uid; });
      loadings.modulesSaving = true;
      // TODO——删除的直接删除了，不用处理——保存模块数据-删除模块数据
      await editCustomQuestionModule(data.map((v) => toRaw(v)));
      await delCustomQuestionModuleIds(delModuleIds);
      questionModules.value = [...toRaw(questionModulesClone.value)];
      // console.log(toRaw(data), 'this is save data');
      loadings.modulesSaving = false;
      modals.modules = false;
      initModuleQuestionData();
    };

    // Draggable Modal
    const dragOption = reactive({
      disabled: false,
      draggable: '.jm-item',
      animation: 150,
      handle: '.anticon-menu',
    });

    // 根据jobId 和 questionModuleId 查询 questionList
    const questionColumns = ref(questionColumn);
    const questionList = ref([] as definitions['CustomQuestion'][]);
    const questionQuering = ref(false);
    const queryQuestionList = async (moduleId: string) => {
      questionQuering.value = true;
      // const { data } = await mock.post(mockPath.getQuestionList, qdata);
      const data = await listCustomQuestionByMId(moduleId);
      questionList.value = data || [] as any;
      questionQuering.value = false;
    };
    const selectRowKeys = ref<string[]>([]);
    const onTableDragEnd = async (list: QuestionI[]) => {
      await editsSeqCustomQuestion(list);
      queryQuestionList(getModuleId(currentModuleId.value, questionModules.value as []).id as string);
    };
    const onTableSelect = ({ selectRowKeys: rowKeys }: {selectRowKeys: string[]}) => { selectRowKeys.value = rowKeys; };

    const initModuleQuestionData = async (_isMounted = false) => {
      const uidIndex = _isMounted ? 0 : questionModules.value.findIndex((v) => v.uid === currentModuleId.value); // 获得选中的uid
      await queryQuestionModuleList();
      currentModuleId.value = (questionModules.value[uidIndex] as any).uid;
      queryQuestionList(getModuleId(currentModuleId.value, questionModules.value as []).id as string);
      ctx.emit('module-change', cloneDeep([...questionModules.value]));
    };
    onMounted(async () => { initModuleQuestionData(true); });

    const currentQuestionData = reactive(new Question() as definitions['CustomQuestion']);

    const handleAddQuestionClick = () => {
      const question = new Question();
      question.seq = questionList.value.length;
      Object.assign(currentQuestionData, question);
      modals.addQuestion = true;
    };

    const handleEditQuestionClick = (question: definitions['CustomQuestion']) => {
      // console.log(parseData(question as QuestionI), 'rrrr');
      Object.assign(currentQuestionData, parseData(question as QuestionI));
      modals.addQuestion = true;
    };

    const questionDeleting = ref(false);
    const handleDelQuestionClick = async (question: definitions['CustomQuestion']|undefined) => {
      questionDeleting.value = true;
      await delCustomQuestionIds(question ? question.id as string : selectRowKeys.value);
      questionDeleting.value = false;
      initModuleQuestionData();
    };

    const handleQuestionOk = async (data: QuestionI) => {
      // console.log(data, 'ParseQuestionI', parseData(data));
      const { assignmentId, id: moduleId } = getModuleId(currentModuleId.value, questionModules.value as []);
      await editCustomQuestion({ ...data, moduleId, assignmentId: assignmentId as string });
      modals.addQuestion = false;
      initModuleQuestionData();
    };

    const moveModule = ref<number>(0);
    const handleMoveModulesClick = async () => {
      loadings.moveLoding = true;
      const { id: moduleId } = questionModules.value[moveModule.value];
      const ids = [...selectRowKeys.value];
      await editsModuleIdCustomQuestion(moduleId as string, ids);
      loadings.moveLoding = false;
      modals.questionMove = false;
      initModuleQuestionData();
    };

    return {
      questionTypeFilter,
      modals,
      loadings,
      dragOption,
      currentModuleId,
      questionModules,
      questionModulesClone,
      handleModuleBtnClick,
      handleModuleManageClick,
      onModuleDragEnd,
      handleAddModuleClick,
      handleDelModuleClick,
      handleSaveModulesClick,
      handleMoveModulesClick,
      questionColumns,
      queryQuestionList,
      questionList,
      questionScore: computed(() => {
        const qscore = questionList.value.map((q) => q.score) as number[];
        // eslint-disable-next-line no-eval
        return eval(qscore.join('+')) || 0;
      }),
      questionQuering,
      selectRowKeys,
      onTableSelect,
      onTableDragEnd,
      moveModule,
      handleAddQuestionClick,
      handleDelQuestionClick,
      handleEditQuestionClick,
      questionDeleting,
      currentQuestionData,
      handleQuestionOk,
    };
  },
});
